/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AccessKey/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AccessKey({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Created/AccessKey"
  
}) {
let createTokenCreatedAccessTokenValueData = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'created_access_token',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let createTokenCreatedAccessTokenValueData1 = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'created_access_token',
})
let createTokenCreatedAccessTokenValueData2 = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'created_access_token',
})
  return (<React.Fragment
>
<div
  data-testid="AccessKey.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceS}
 disabled={true}
 data="create_token.created_access_token"
 value={createTokenCreatedAccessTokenValueData}
>
{childProps => (
<React.Fragment>
<div
  data-testid="AccessKey.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Access Key"
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 marginTop={-4}
 data="create_token.created_access_token"
 value={createTokenCreatedAccessTokenValueData1}
 data="create_token.created_access_token"
 text={createTokenCreatedAccessTokenValueData2}
/>
</div>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}